import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { NoticeIconSelect, NoticeItem } from '@delon/abc/notice-icon';
import { LocaleData } from '@delon/theme';
import { NzStringTemplateOutletDirective } from 'ng-zorro-antd/core/outlet';
import { NzListComponent, NzListItemComponent, NzListItemMetaComponent } from 'ng-zorro-antd/list';
import { NzTagComponent } from 'ng-zorro-antd/tag';

@Component({
  selector: 'app-notification-tab',
  templateUrl: './notification-tab.component.html',
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgTemplateOutlet,
    NzStringTemplateOutletDirective,
    NzListComponent,
    NzListItemComponent,
    NzListItemMetaComponent,
    NzTagComponent
  ]
})
export class NotificationTabComponent {
  @Input() locale: LocaleData = {};
  @Input() data!: NoticeItem;
  @Output() readonly selected = new EventEmitter<NoticeIconSelect>();
  @Output() readonly cleared = new EventEmitter<string>();

  onClick(item: NoticeItem): void {
    this.selected.emit({ title: this.data.title, item });
  }

  onClear(): void {
    this.cleared.emit(this.data.title);
  }
}
